import react, {useEffect, useState} from 'react'
import {Link, useNavigate} from "react-router-dom";
import commonStyles from "../commonStyles";
import React from "react";
import CardRisultato from "./CardRisultato";
import {db} from "../utils/firebase";
import {ref, onValue, set} from "firebase/database";
import {SyncLoader} from "react-spinners";

function Risultati(props) {
    const [salvaPersone, setsalvaPersone] = useState(props.persone);
    const [isLoaded, setIsLoaded] = useState(false)
    const [Shared, setShared] = useState(false)
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const [shareURL, setShareURL] = useState("")

    function getUID() {
        return Date.now().toString(36);
    }

    const writeUserData = (array, shareId) => {
        set(ref(db, 'results/' + shareId), {
            friendsArray: array
        });
    }

    const handleShare = () => {
        if (id === "" || id === null) {
            if (!Shared) {
                const shareId = getUID()
                writeUserData(salvaPersone, shareId)
                setShareURL(window.document.URL + "?id=" + shareId)
            }
            navigator.clipboard.writeText(shareURL);
            props.openAlert("Link Copied to Clipboard")
        } else {
            navigator.clipboard.writeText(window.document.URL);
            props.openAlert("Link Copied to Clipboard")
        }
    }

    const getData = (id) => {
        const query = ref(db, "/results/" + id);
        return onValue (query, (snapshot) => {
            const data = snapshot.val();

            if (snapshot.exists()) {
                setsalvaPersone(data.friendsArray)
            }
        });
    }

    useEffect(() => {
        if (salvaPersone.length !== 0) {
            setIsLoaded(true)
        } else {
            getData(id)
        }
    }, []);

    useEffect(() => {
        if (salvaPersone.length !== 0) {
            setIsLoaded(true)
        }
    }, [salvaPersone]);

    let navigate = useNavigate()

    return(
        (isLoaded)?
        <div className="container" style={ commonStyles.divRisultati }>
            <div className="row" style={{ margin: 'auto', flexWrap: 'wrap' }}>
                <div className="col" style={{ margin: 'auto', flexWrap: 'wrap' }}>

                    <hr style={ commonStyles.hr }/>
                    <div style={{ color: 'white' }}>
                        <button onClick={() => {navigate(Shared? -2 : -1)}} className={"btn coolbtn btn-outline-light ms-2 px-3"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" className="bi bi-box-arrow-left" viewBox="0 2 16 16">
                                <path fillRule="evenodd"
                                      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"/>
                                <path fillRule="evenodd"
                                      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>
                            </svg>
                        </button>
                        <button onClick={() => {
                            handleShare()
                            setShared(true)
                        }} className={"btn coolbtn btn-outline-light ms-2 me-2 px-3"}>
                            <>SHARE </>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 className="bi bi-share-fill ms-1" viewBox="0 0 16 16">
                                <path
                                    d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                            </svg>
                        </button>
                    </div>
                    <hr style={ commonStyles.hr }/>

                    {
                        salvaPersone.map(persona => (
                            <CardRisultato
                                key={ persona.id }
                                persona = { persona }
                            />
                        ))
                    }
                </div>
            </div>
        </div>
            : <SyncLoader
            color={"#00addf"}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}
        />
    );
}

export default Risultati